export default __webpack_public_path__ + "static/media/ranking-gain-exp-step1.1b56478a.png";